var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4265",
    "data-name": "Group 4265",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.918,
    height: 22.917,
    viewBox: "0 0 22.918 22.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32118",
    "data-name": "Path 32118",
    d: "M394.328,727.127a1.347,1.347,0,1,0,1.348,1.347A1.347,1.347,0,0,0,394.328,727.127Zm-5.99,1.728a5.659,5.659,0,1,0,5.66,5.659A5.666,5.666,0,0,0,388.338,728.855Zm0,9.285a3.625,3.625,0,1,1,3.626-3.626A3.63,3.63,0,0,1,388.338,738.139Zm11.42-8.329a6.9,6.9,0,0,0-6.9-6.9h-9.111a6.9,6.9,0,0,0-6.9,6.9v9.112a6.9,6.9,0,0,0,6.9,6.9h9.111a6.9,6.9,0,0,0,6.9-6.9Zm-2.162,9.112a4.741,4.741,0,0,1-4.741,4.741h-9.111A4.741,4.741,0,0,1,379,738.922V729.81a4.742,4.742,0,0,1,4.742-4.741h9.111a4.741,4.741,0,0,1,4.741,4.741Z",
    transform: "translate(-376.84 -722.907)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram1);
export default __webpack_public_path__ + "static/media/instagram_1.51939b5d845e9d19378b7a35a5d29e4b.svg";
export { ForwardRef as ReactComponent };